module.exports = __webpack_public_path__ + "img/ddt.817aa8f1.jpg";